import { Avatar, Checkbox, ListItem } from '@mui/material';
import { Checkmark, CheckmarkChecked } from 'Images';
import { ResetFilterButtons } from 'Modules/Suppliers/SuppliersMain/ResultsPages/Header/DynamicAdvancedFilter/ResetFilterButtons';
import { Fragment } from 'react';

interface ICheckboxList {
  props?: any;
  option: string;
  isSelected: boolean;
  onClickCheckbox?: (value: string) => void;
  resetHandler?: Function;
  renderResetBtn: boolean;
}

export const CheckboxList = ({
  option,
  isSelected,
  onClickCheckbox,
  resetHandler,
  renderResetBtn,
  ...props
}: ICheckboxList) => {
  return (
    <Fragment key={option}>
      <ListItem
        {...props}
        sx={{
          maxHeight: '40px',
          fontWeight: isSelected ? '700 !important' : '400 !important',
          fontSize: '18px',
          lineHeight: '22px',
          '&:hover': {
            bgcolor: 'primary.shade_100',
            cursor: 'pointer',
          },
          '&.Mui-selected': {
            fontWeight: '400 !important',
            bgcolor: 'primary.shade_100',
          },
        }}
        onClick={() => (onClickCheckbox ? onClickCheckbox(option) : undefined)}
      >
        <Checkbox
          icon={
            <Avatar
              alt=''
              src={Checkmark}
              sx={{ width: '24px', height: '24px' }}
            />
          }
          checkedIcon={
            <Avatar
              alt=''
              src={CheckmarkChecked}
              sx={{ width: '24px', height: '24px' }}
            />
          }
          checked={isSelected}
        />
        {option}
      </ListItem>
      {renderResetBtn && (
        <ResetFilterButtons
          resetCallback={() => (resetHandler ? resetHandler() : undefined)}
          sx={{
            width: '295px',
            bottom: '1px',
            p: '6px 0 6px 15px',
            justifyContent: 'flex-start',
            borderRadius: '0 0 0 12px',
          }}
        />
      )}
    </Fragment>
  );
};
